import { Component, OnInit } from "@angular/core";
import { AlertService } from "./alert.service";
@Component({
  standalone: false,
  selector: "app-alert",
  templateUrl: "./alert.component.html",
  styleUrls: ["./alert.component.scss"],
})
export class AlertComponent implements OnInit {  constructor(public alertService: AlertService) {}
  ngOnInit(): void {}
  onClose() {
    this.alertService.closeAlert();
  }
}
